import { Profile, Project, Slide } from '../types';

export const BRAND = {
  dark: "#0d0d0d",
  panel: "#252A34",
  accent: "#FFFFFF",
  accent2: "#FFFFFF",
  text: "#EAEAEA",
};

export const PROFILE: Profile = {
  name: "Hugo Esquerdo",
  role: "Takedown & Internet Specialist",
  headline: "Eu crio produtos, jogos e sistemas que realmente resolvem problemas.",
  location: "Brasil - Volta Redonda - RJ",
  bio: `Dedicated to taking down malicious and infringing content, with the goal of making the internet a safer place.\n(And yes, sometimes I also build some seriously cool stuffs.) 😎`,
  contacts: {
    email: "contact@hugoesquerdo.com",
    phone: "+55 11 99999-0000",
    github: "https://github.com/",
    linkedin: "https://www.linkedin.com/in/hugoesquerdo/",
    instagram: "https://www.instagram.com/hugodutt/",
  },
  companies: ["Space Y", "Melta", "ClosedAI", "Booble", "Lentflix", "Xwitter"],
  avatar: "/personagem00.png",
};

export const TAGS = ["Produtos", "IA", "Jogos", "Pixel Art", "Segurança", "Fintech"];

export const PROJECTS: Project[] = [
  { title: "VDM Duels", subtitle: "Shooter 1v1 em plataforma, PixiJS + Colyseus", tags: ["Jogos", "Produtos"], year: "2025" },
  { title: "take.down (takedown bot)", subtitle: "IA para varredura de domínios e remoção de conteúdos abusivos", tags: ["Segurança", "IA", "Produtos"], year: "2025" },
  { title: "Notten — marca e e‑commerce", subtitle: "Brand, site e operações enxutas", tags: ["Produtos"], year: "2024" },
  { title: "teamO.love", subtitle: "Cápsula do tempo online para casais", tags: ["Produtos"], year: "2025" },
  { title: "Pixel Art Packs", subtitle: "Sprites e backgrounds 2D ultra detalhados", tags: ["Pixel Art", "Jogos"], year: "2024" },
  { title: "Fraude Watch", subtitle: "Dashboard de deteção e workflow de remoção", tags: ["Segurança", "Fintech", "Produtos"], year: "2023" },
];

// Slides configuration for the main showcase
export const RIGHT_SLIDES: Slide[] = [
  {
    id: 'solar',
    title: 'Cosmic Navigator',
    subtitle: 'Command Your Journey Across a Living, Breathing Cosmos.',
    cta: undefined,
    href: '#solar',
    bg: 'radial-gradient(120% 120% at 80% 20%, rgba(14,165,233,0.25), transparent 60%), radial-gradient(120% 160% at 20% 100%, rgba(124,58,237,0.22), transparent 60%)',
    // Cosmic theme: Blue -> Purple -> Pink gradient for space-like effect
    gradientColors: ['rgba(59,130,246,0.8)', 'rgba(147,51,234,0.6)', 'rgba(236,72,153,0.8)'],
  },
  {
    id: 'trace',
    title: 'TRACE.',
    subtitle: 'TRACE rastreia domínios maliciosos e mapeia as entidades responsáveis para takedown.',
    cta: 'Overview',
    href: '#trace',
    bg: 'radial-gradient(100% 140% at 10% 10%, rgba(255,255,255,0.06), transparent 55%), radial-gradient(120% 130% at 90% 90%, rgba(255,255,255,0.08), transparent 60%)',
    gradientColors: ['rgba(34,197,94,0.8)', 'rgba(59,130,246,0.6)', 'rgba(245,158,11,0.8)'],
  },
];
